/* eslint-disable react/no-multi-comp */
import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateSearchButton = forwardRef(({ onClick }, ref) => {
  return (
    <button
      type="button"
      ref={ref}
      onClick={onClick}
      className="btn btn-link p-0 text-decoration-underline text-primary f-12 filter-btn"
    >
      Date Search
    </button>
  );
});

DateSearchButton.displayName = 'DateSearchButton';

const DateSearchFilter = ({
  dateRange,
  onChange,
  className = '',
  style = {},
}) => {
  const hasSelectedDateRange =
    Boolean(dateRange?.startDate) || Boolean(dateRange?.endDate);

  return (
    <div
      className={`date-search-filter ${className}`.trim()}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        ...style,
      }}
    >
      <DatePicker
        selected={dateRange?.startDate}
        onChange={onChange}
        startDate={dateRange?.startDate}
        endDate={dateRange?.endDate}
        selectsRange
        dateFormat="dd/MM/yyyy"
        popperPlacement="bottom-start"
        customInput={<DateSearchButton />}
      />
      {hasSelectedDateRange && (
        <button
          type="button"
          className="btn btn-link p-0 text-primary f-12"
          style={{ lineHeight: 1 }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onChange([null, null]);
          }}
        >
          x
        </button>
      )}
    </div>
  );
};

export default DateSearchFilter;
